import { defaultConfig } from './Config';
import { EntityContext } from './EntityContext';
import { EntityAnonymizer } from './ner';
import { BankAccountSanitizer, CookieSanitizer, CreditCardSanitizer, CryptoWalletSanitizer, DateSanitizer, DeviceIdSanitizer, EmailSanitizer, GovernmentIdSanitizer, IpAddressSanitizer, MacAddressSanitizer, PhoneNumberSanitizer, SanitizerPipeline, SSNSanitizer, UsernameSanitizer } from './sanitizers';
export function createAnonymizationPipeline(config = defaultConfig, context = new EntityContext()) {
    const sanitizerPipeline = new SanitizerPipeline(context);
    sanitizerPipeline.addSanitizer(new BankAccountSanitizer(context, config.sanitization.bankAccounts));
    sanitizerPipeline.addSanitizer(new CryptoWalletSanitizer(context, config.sanitization.cryptoWallets));
    sanitizerPipeline.addSanitizer(new MacAddressSanitizer(context, config.sanitization.macAddresses));
    sanitizerPipeline.addSanitizer(new DeviceIdSanitizer(context, config.sanitization.deviceIds));
    sanitizerPipeline.addSanitizer(new CookieSanitizer(context, config.sanitization.cookies));
    sanitizerPipeline.addSanitizer(new DateSanitizer(context, config.sanitization.dates));
    sanitizerPipeline.addSanitizer(new PhoneNumberSanitizer(context, config.sanitization.phoneNumbers));
    sanitizerPipeline.addSanitizer(new EmailSanitizer(context, config.sanitization.emails));
    sanitizerPipeline.addSanitizer(new CreditCardSanitizer(context, config.sanitization.creditCards));
    sanitizerPipeline.addSanitizer(new SSNSanitizer(context, config.sanitization.ssns));
    sanitizerPipeline.addSanitizer(new UsernameSanitizer(context, config.sanitization.usernames));
    sanitizerPipeline.addSanitizer(new IpAddressSanitizer(context, config.sanitization.ipAddresses));
    sanitizerPipeline.addSanitizer(new GovernmentIdSanitizer(context, config.sanitization.governmentIds));
    const entityAnonymizer = new EntityAnonymizer(context, config.ner);
    return { context, sanitizerPipeline, entityAnonymizer };
}
export function sanitizeText(text, pipeline) {
    return pipeline.sanitize(text);
}
export async function sanitizeAndAnonymize(text, pipeline, anonymizer, nerPipeline) {
    const sanitizedText = sanitizeText(text, pipeline);
    const results = await nerPipeline(sanitizedText);
    const detectedEntities = anonymizer.reconstructEntities(results.filter((token) => (token.entity_group || token.entity) !== 'O'));
    const anonymizedText = anonymizer.anonymize(sanitizedText, detectedEntities);
    return {
        sanitizedText,
        anonymizedText,
        entityMaps: anonymizer.getContext().getAllMaps()
    };
}
export function deanonymizeText(text, context) {
    return context.deanonymize(text);
}
